import { getArea } from '@rendora/common/utils/config';
import type { TrackingAdapter } from '../core';

declare global {
  interface Window {
    aplus_queue?: IActionItem[];
  }
}

export interface IActionItem {
  action: string;
  arguments?: unknown[];
}

const ensureQueue = (): IActionItem[] | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  window.aplus_queue = window.aplus_queue ?? [];
  return window.aplus_queue ?? null;
};

export class AliQuickPlusService {
  public static setUserId(userId: string) {
    const queue = ensureQueue();
    if (!queue) return;
    const idPrefixMap: Record<string, string> = {
      CN: '',
      US: 'en',
      HK: 'hk',
    };
    const prefix = idPrefixMap[getArea().toUpperCase()];
    const normalizedId = String(userId).trim();
    const loginId = prefix ? `yyuser_${prefix}_${normalizedId}` : `yyuser_${normalizedId}`;

    queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['_user_id', loginId],
    });
  }

  public static track(eventName: string, data: Record<string, unknown>) {
    const queue = ensureQueue();
    if (!queue) return;
    queue.push({
      action: 'aplus.record',
      arguments: [eventName, 'OTHER', data],
    });
  }
}

export const createAliTrackingAdapter = (): TrackingAdapter => {
  return {
    name: 'quickaplus',
    init: () => {
      ensureQueue();
    },
    track: (eventName, data) => {
      AliQuickPlusService.track(eventName, data);
    },
    login: userId => {
      AliQuickPlusService.setUserId(String(userId));
    },
  };
};
